/** Parse a raw User-Agent string into a human-readable "Browser on OS" label.
 *  Returns `fallback` when the UA is absent or unrecognised. */
export function parseUserAgent(ua: string | null | undefined, fallback: string): string {
  if (!ua) return fallback;
  let browser = 'Unknown';
  if (ua.includes('Edg/')) browser = 'Edge';
  else if (ua.includes('Chrome/')) browser = 'Chrome';
  else if (ua.includes('Firefox/')) browser = 'Firefox';
  else if (ua.includes('Safari/')) browser = 'Safari';

  let os = 'Unknown';
  if (ua.includes('Windows')) os = 'Windows';
  else if (ua.includes('Macintosh') || ua.includes('Mac OS')) os = 'macOS';
  else if (ua.includes('iPhone') || ua.includes('iPad')) os = 'iOS';
  else if (ua.includes('Android')) os = 'Android';
  else if (ua.includes('Linux')) os = 'Linux';

  if (browser === 'Unknown' && os === 'Unknown') return fallback;
  return `${browser} on ${os}`;
}
